export const translations = {
  en: {
    // Navigation
    map: 'Map',
    about: 'About',
    privacy: 'Privacy',
    terms: 'Terms',
    report: 'Report',
    providers: 'Providers',

    // Map Screen
    locationsFound: 'locations found',
    loading: 'Loading...',
    dhsOfficial: 'Shelter & Housing',
    openNow: 'Open Now',
    openToday: 'Open Today',

    // Service Types
    food: 'Food',
    shelter: 'Shelter',
    hygiene: 'Hygiene',
    medical: 'Medical',
    social: 'Social Services',
    legal: 'Legal Aid',
    mental: 'Mental Health',
    intakeCenter: 'Intake Center',
    dropInCenter: 'Drop-In Center',
    warmingCenter: 'Warming Center',
    coolingCenter: 'Cooling Center',
    hospitals: 'Hospitals',
    freeWifiLinkNYC: 'Free WiFi & Charging',
    publicRestrooms: 'Public Restrooms',
    mentalHealthCrisis: 'Mental Health Crisis',
    youthServices: 'Youth (16-24)',
    benefitsId: 'Benefits & ID',
    caseManagement: 'Case Management',
    dvHotline: 'DV Hotline',
    dvHotlineCall: 'Call 1-800-621-HOPE',
    dvHotlineDesc: 'Shelter locations are confidential. Tap to call for help.',

    // Location Details
    phone: 'Phone',
    milesAway: 'miles away',
    services: 'Services',
    operatingHours: 'Operating Hours',
    weeklyHours: 'Weekly Hours',
    beds: 'beds',
    serves: 'Serves',
    people: 'people',
    capacity: 'Capacity',

    // Days of week
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',

    // Status
    openNowStatus: 'Open Now',
    closed: 'Closed',
    open24Hours: 'Open 24 Hours',
    closedToday: 'Closed Today',

    // DHS Info Card
    dhsTitle: 'NYC Official Resources',
    dhsDescription: 'For immediate emergency shelter placement and official NYC homeless services, please contact:',
    call311: 'Call 311',
    dhsBackButton: '← Back to Map',

    // About Screen
    aboutTitle: 'About Hope for NYC',
    aboutMission: 'Our Mission',
    aboutMissionText: 'Hope for NYC is a free, privacy-focused directory of essential services for homeless individuals in New York City. We believe everyone deserves access to shelter, food, and basic services with dignity.',
    aboutValues: 'Our Values',
    privacyFirst: 'Privacy First',
    privacyFirstDesc: 'No user accounts, no tracking, no data collection. Your privacy is paramount.',
    alwaysFree: 'Always Free',
    alwaysFreeDesc: 'No ads, no monetization. This service will always be free.',
    dignifiedAccess: 'Dignified Access',
    dignifiedAccessDesc: 'Clean, respectful interface designed with care.',
    accurateInfo: 'Accurate Information',
    accurateInfoDesc: 'Real-time hours, current status, verified locations.',
    aboutDataSources: 'Data Sources',
    aboutDataSourcesText: 'Information is compiled from NYC Open Data, Department of Homeless Services, 311 reports, and community organizations. We verify and update regularly.',
    reportIssue: 'Report an Issue',
    reportIssueText: 'Found incorrect information? Please let us know:',
    reportEmail: 'campuslens.help@gmail.com',

    // Error messages
    locationError: 'Unable to get your location',
    loadError: 'Error loading services',

    // Buttons
    centerMap: 'Center map on my location',
    call: 'Call',
    directions: 'Directions',

    // DHS Card
    safeOptions: 'Safe Options',
    officialDHSResources: 'Official DHS Resources',
    confidentialSheltersNotListed: 'For safety, confidential shelters are not listed on public maps.',
    contactDHSFor311: 'Please contact the Department of Homeless Services (DHS) or call 311 for placement.',
    backToMap: 'Back to Map',

    // Popup content
    servesCapacity: 'Serves',
    capacityLabel: 'Capacity',
    today: 'Today',
    access247: '24/7 Access',
    viewAllHours: 'View all hours',
    hoursNotAvailable: 'Hours not available',
    hours24: '24 Hours',

    // Food sub-filters
    hotMeals: 'Soup Kitchen',
    groceries: 'Food Pantry',

    // Mental Health Crisis sub-filters
    cpepEmergency: 'CPEP (ER)',
    otherCrisis: 'Clinics & Hotlines',

    // Front Door Services
    entryPoint: 'ENTRY POINT. Go here 24/7 to get a bed assigned.',
    safeHaven: 'SAFE HAVEN. Chairs, food, and showers available 24/7.',
    alwaysOpen247: 'ALWAYS OPEN (24/7)',

    // DHS Subtitle
    officialDHSEntryPoints: 'Official DHS Entry Points',

    // Privacy & Terms
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',

    // DHS Card Content
    dhsWarning: 'Confidential shelter locations are not mapped for safety. To get a bed, you must go to one of the Intake Centers below.',
    cityServices: 'City Services',
    call988: 'Call 988',
    mentalHealth: 'Mental Health',
    intakeCentersTitle: 'Intake Centers (To get a bed)',
    intakeCentersSubtext: 'These are open 24/7. You must go here to apply for placement.',
    dropInCentersTitle: 'Drop-In Centers (Immediate Safe Space)',
    dropInCentersSubtext: 'Open 24/7. No application needed. Chairs, food, and showers available.',
    familiesWithKids: 'Families w/ Kids:',
    singleMen: 'Single Men:',
    singleWomen: 'Single Women:',
    adultFamilies: 'Adult Families (No kids):',
    manhattan: 'Manhattan:',
    bronx: 'Bronx:',
    brooklyn: 'Brooklyn:',
    statenIsland: 'Staten Island:',

    // About Screen
    aboutHeader: 'About Hope for NYC',
    aboutIntro: 'Hope for NYC is a free tool that helps people find shelters, food pantries, and essential social services across New York City. We exist to make finding help faster and easier.',
    whoItsFor: 'Who It\'s For',
    whoItsForText: 'This site is for anyone currently in need, as well as the social workers, volunteers, and organizations providing help.',
    whatItIsNot: 'What It Is NOT',
    whatItIsNotText: 'We are a directory. We are not a shelter, a government agency, or a donation platform. We do not manage the facilities listed here.',
    dataSources: 'Data Sources',
    dataSourcesText: 'Our information comes from NYC Open Data and verified service providers.',
    pleaseNote: 'Please Note:',
    availabilityNote: 'Availability and hours can change quickly. We strongly recommend calling a location ahead of time if you can.',
    privacyNote: 'Privacy Note',
    privacyNoteText: 'Your Dignity Matters. No Ads. No Selling Data. No Tracking beyond what is needed to make the site work.',

    // How It Works Screen
    howItWorksHeader: 'How This Works',
    step: 'Step',
    step1Title: 'Open the Map',
    step1Desc: 'As soon as you open the app, you will see services near your current location.',
    step2Title: 'Tap a Location',
    step2Desc: 'Click on any pin to see what services they offer, their operating hours, and if there are specific requirements.',
    step3Title: 'Use Filters',
    step3Desc: 'Need food right now? Use the "Open Now" or "Tonight" filters.',
    step4Title: 'Call Before You Go',
    step4Desc: 'If a phone number is listed, try to call to ensure they have space.',

    // Report Issue Screen
    reportIssueHeader: 'Report an Issue',
    reportIssueDesc: 'Help us keep our information accurate. If you notice a problem with a listing, please let us know.',
    selectIssueType: 'Select Issue Type',
    selectAnIssue: '-- Select an issue --',
    issueTypeClosed: 'Location permanently closed',
    issueTypeHours: 'Hours incorrect',
    issueTypeFull: 'Facility full/unavailable',
    issueTypeReferral: 'Referral required',
    issueTypeOther: 'Other',
    locationNameLabel: 'Location Name',
    locationPlaceholder: 'e.g., Holy Apostles Soup Kitchen',
    briefExplanation: 'Brief Explanation',
    explanationPlaceholder: 'Please provide details about the issue...',
    charactersCount: 'characters',
    submitting: 'Submitting...',
    submitReport: 'Submit Report',
    reportSuccess: 'Thank you! Your report has been submitted successfully.',
    reportError: 'There was an error submitting your report. Please try again.',
    reportNote: 'Your report will be sent to our team for review. For urgent issues, please contact the service provider directly or call 311.',
    required: '*',
    noteLabel: 'Note:',
    pleaseSelectIssue: 'Please select an issue type.',
    pleaseEnterLocation: 'Please enter the location name.',
    pleaseProvideExplanation: 'Please provide a brief explanation.',
    pleaseCompleteCaptcha: 'Please complete the reCAPTCHA verification.',
  },

  es: {
    // Navigation
    map: 'Mapa',
    about: 'Acerca de',
    privacy: 'Privacidad',
    terms: 'Términos',
    report: 'Reportar',
    providers: 'Proveedores',

    // Map Screen
    locationsFound: 'ubicaciones encontradas',
    loading: 'Cargando...',
    dhsOfficial: 'Refugio y Vivienda',
    openNow: 'Abierto Ahora',
    openToday: 'Abierto Hoy',

    // Service Types
    food: 'Comida',
    shelter: 'Refugio',
    hygiene: 'Higiene',
    medical: 'Médico',
    social: 'Servicios Sociales',
    legal: 'Ayuda Legal',
    mental: 'Salud Mental',
    intakeCenter: 'Centro de Admisión',
    dropInCenter: 'Centro de Acogida',
    warmingCenter: 'Centro de Calefacción',
    coolingCenter: 'Centro de Enfriamiento',
    hospitals: 'Hospitales',
    freeWifiLinkNYC: 'WiFi Gratis y Carga',
    publicRestrooms: 'Baños Públicos',
    mentalHealthCrisis: 'Crisis de Salud Mental',
    youthServices: 'Jóvenes (16-24)',
    benefitsId: 'Beneficios e ID',
    caseManagement: 'Gestión de Casos',
    dvHotline: 'Línea de Violencia Doméstica',
    dvHotlineCall: 'Llamar 1-800-621-HOPE',
    dvHotlineDesc: 'Las ubicaciones de refugios son confidenciales. Toque para llamar.',

    // Location Details
    phone: 'Teléfono',
    milesAway: 'millas de distancia',
    services: 'Servicios',
    operatingHours: 'Horario',
    weeklyHours: 'Horario Semanal',
    beds: 'camas',
    serves: 'Sirve a',
    people: 'personas',
    capacity: 'Capacidad',

    // Days of week
    sunday: 'Domingo',
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',

    // Status
    openNowStatus: 'Abierto Ahora',
    closed: 'Cerrado',
    open24Hours: 'Abierto 24 Horas',
    closedToday: 'Cerrado Hoy',

    // DHS Info Card
    dhsTitle: 'Recursos Oficiales de NYC',
    dhsDescription: 'Para colocación inmediata en refugios de emergencia y servicios oficiales para personas sin hogar de NYC, por favor contacte:',
    call311: 'Llamar al 311',
    dhsBackButton: '← Volver al Mapa',

    // About Screen
    aboutTitle: 'Acerca de Hope for NYC',
    aboutMission: 'Nuestra Misión',
    aboutMissionText: 'Hope for NYC es un directorio gratuito y enfocado en la privacidad de servicios esenciales para personas sin hogar en la Ciudad de Nueva York. Creemos que todos merecen acceso a refugio, comida y servicios básicos con dignidad.',
    aboutValues: 'Nuestros Valores',
    privacyFirst: 'Privacidad Primero',
    privacyFirstDesc: 'Sin cuentas de usuario, sin rastreo, sin recopilación de datos. Su privacidad es primordial.',
    alwaysFree: 'Siempre Gratis',
    alwaysFreeDesc: 'Sin anuncios, sin monetización. Este servicio siempre será gratuito.',
    dignifiedAccess: 'Acceso Digno',
    dignifiedAccessDesc: 'Interfaz limpia y respetuosa diseñada con cuidado.',
    accurateInfo: 'Información Precisa',
    accurateInfoDesc: 'Horarios en tiempo real, estado actual, ubicaciones verificadas.',
    aboutDataSources: 'Fuentes de Datos',
    aboutDataSourcesText: 'La información se compila de NYC Open Data, Departamento de Servicios para Personas Sin Hogar, reportes del 311 y organizaciones comunitarias. Verificamos y actualizamos regularmente.',
    reportIssue: 'Reportar un Problema',
    reportIssueText: '¿Encontró información incorrecta? Por favor háganoslo saber:',
    reportEmail: 'campuslens.help@gmail.com',

    // Error messages
    locationError: 'No se puede obtener su ubicación',
    loadError: 'Error al cargar servicios',

    // Buttons
    centerMap: 'Centrar mapa en mi ubicación',
    call: 'Llamar',
    directions: 'Direcciones',

    // DHS Card
    safeOptions: 'Opciones Seguras',
    officialDHSResources: 'Recursos Oficiales del DHS',
    confidentialSheltersNotListed: 'Por seguridad, los refugios confidenciales no aparecen en mapas públicos.',
    contactDHSFor311: 'Por favor contacte al Departamento de Servicios para Personas Sin Hogar (DHS) o llame al 311 para colocación.',
    backToMap: 'Volver al Mapa',

    // Popup content
    servesCapacity: 'Sirve a',
    capacityLabel: 'Capacidad',
    today: 'Hoy',
    access247: 'Acceso 24/7',
    viewAllHours: 'Ver todos los horarios',
    hoursNotAvailable: 'Horario no disponible',
    hours24: '24 Horas',

    // Food sub-filters
    hotMeals: 'Cocina Comunitaria',
    groceries: 'Despensa de Alimentos',

    // Mental Health Crisis sub-filters
    cpepEmergency: 'CPEP (Urgencias)',
    otherCrisis: 'Clínicas y Líneas',

    // Front Door Services
    entryPoint: 'PUNTO DE ENTRADA. Venga aquí 24/7 para que le asignen una cama.',
    safeHaven: 'REFUGIO SEGURO. Sillas, comida y duchas disponibles 24/7.',
    alwaysOpen247: 'SIEMPRE ABIERTO (24/7)',

    // DHS Subtitle
    officialDHSEntryPoints: 'Puntos de Entrada Oficiales del DHS',

    // Privacy & Terms
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',

    // DHS Card Content
    dhsWarning: 'Las ubicaciones de refugios confidenciales no se muestran en el mapa por seguridad. Para obtener una cama, debe ir a uno de los Centros de Admisión a continuación.',
    cityServices: 'Servicios de la Ciudad',
    call988: 'Llamar al 988',
    mentalHealth: 'Salud Mental',
    intakeCentersTitle: 'Centros de Admisión (Para obtener una cama)',
    intakeCentersSubtext: 'Están abiertos 24/7. Debe ir aquí para solicitar colocación.',
    dropInCentersTitle: 'Centros de Acogida (Espacio Seguro Inmediato)',
    dropInCentersSubtext: 'Abierto 24/7. No se necesita solicitud. Sillas, comida y duchas disponibles.',
    familiesWithKids: 'Familias con Niños:',
    singleMen: 'Hombres Solteros:',
    singleWomen: 'Mujeres Solteras:',
    adultFamilies: 'Familias de Adultos (Sin niños):',
    manhattan: 'Manhattan:',
    bronx: 'Bronx:',
    brooklyn: 'Brooklyn:',
    statenIsland: 'Staten Island:',

    // About Screen
    aboutHeader: 'Acerca de Hope for NYC',
    aboutIntro: 'Hope for NYC es una herramienta gratuita que ayuda a las personas a encontrar refugios, despensas de alimentos y servicios sociales esenciales en toda la Ciudad de Nueva York. Existimos para hacer que encontrar ayuda sea más rápido y fácil.',
    whoItsFor: 'Para Quién Es',
    whoItsForText: 'Este sitio es para cualquier persona que actualmente lo necesite, así como para los trabajadores sociales, voluntarios y organizaciones que brindan ayuda.',
    whatItIsNot: 'Qué NO Es',
    whatItIsNotText: 'Somos un directorio. No somos un refugio, una agencia gubernamental ni una plataforma de donaciones. No administramos las instalaciones listadas aquí.',
    dataSources: 'Fuentes de Datos',
    dataSourcesText: 'Nuestra información proviene de NYC Open Data y proveedores de servicios verificados.',
    pleaseNote: 'Tenga en Cuenta:',
    availabilityNote: 'La disponibilidad y los horarios pueden cambiar rápidamente. Recomendamos encarecidamente llamar a una ubicación con anticipación si puede.',
    privacyNote: 'Nota de Privacidad',
    privacyNoteText: 'Su Dignidad Importa. Sin Anuncios. Sin Venta de Datos. Sin Seguimiento más allá de lo necesario para que el sitio funcione.',

    // How It Works Screen
    howItWorksHeader: 'Cómo Funciona',
    step: 'Paso',
    step1Title: 'Abra el Mapa',
    step1Desc: 'Tan pronto como abra la aplicación, verá servicios cerca de su ubicación actual.',
    step2Title: 'Toque una Ubicación',
    step2Desc: 'Haga clic en cualquier pin para ver qué servicios ofrecen, sus horarios de operación y si hay requisitos específicos.',
    step3Title: 'Use Filtros',
    step3Desc: '¿Necesita comida ahora mismo? Use los filtros "Abierto Ahora" o "Esta Noche".',
    step4Title: 'Llame Antes de Ir',
    step4Desc: 'Si se indica un número de teléfono, intente llamar para asegurarse de que tengan espacio.',

    // Report Issue Screen
    reportIssueHeader: 'Reportar un Problema',
    reportIssueDesc: 'Ayúdenos a mantener nuestra información precisa. Si nota un problema con una ubicación, por favor háganoslo saber.',
    selectIssueType: 'Seleccionar Tipo de Problema',
    selectAnIssue: '-- Seleccione un problema --',
    issueTypeClosed: 'Ubicación permanentemente cerrada',
    issueTypeHours: 'Horarios incorrectos',
    issueTypeFull: 'Instalación llena/no disponible',
    issueTypeReferral: 'Se requiere referencia',
    issueTypeOther: 'Otro',
    locationNameLabel: 'Nombre de la Ubicación',
    locationPlaceholder: 'ej., Holy Apostles Soup Kitchen',
    briefExplanation: 'Breve Explicación',
    explanationPlaceholder: 'Por favor proporcione detalles sobre el problema...',
    charactersCount: 'caracteres',
    submitting: 'Enviando...',
    submitReport: 'Enviar Reporte',
    reportSuccess: '¡Gracias! Su reporte ha sido enviado exitosamente.',
    reportError: 'Hubo un error al enviar su reporte. Por favor intente de nuevo.',
    reportNote: 'Su reporte será enviado a nuestro equipo para revisión. Para problemas urgentes, contacte al proveedor de servicios directamente o llame al 311.',
    required: '*',
    noteLabel: 'Nota:',
    pleaseSelectIssue: 'Por favor seleccione un tipo de problema.',
    pleaseEnterLocation: 'Por favor ingrese el nombre de la ubicación.',
    pleaseProvideExplanation: 'Por favor proporcione una breve explicación.',
    pleaseCompleteCaptcha: 'Por favor complete la verificación reCAPTCHA.',
  }
};

export type Language = 'en' | 'es';
export type TranslationKey = keyof typeof translations.en;
